import { useNavigate } from 'react-router-dom';
import { Button, responsive } from '@vp/swan';
import { __ } from '@99designs/i18n';
import { useNavigationClicked, useStepContext } from '@99designs/swan-wizard';
import { REVIEW_ROUTE_SEGMENT } from '../../lib/briefNavigation';
import { useFieldProcessing } from './FieldProcessingProvider';

const ResponsiveButton = responsive(Button);

export const ReviewBriefButton = () => {
    const { processingFields } = useFieldProcessing();
    const isProcessing = processingFields.length > 0;
    const nav = useNavigate();
    const { validate, currentStep } = useStepContext();

    const { trackNavigationClick } = useNavigationClicked({
        label: 'Content: Bottom Bar',
    });

    return (
        <ResponsiveButton
            data-testid="brief-review-button"
            skin="primary"
            width="full-width"
            onClick={async () => {
                const isValid = await validate(currentStep);
                if (!isValid) {
                    return;
                }
                const currentPath = window.location.pathname;
                const reviewPath = `${currentPath}/${REVIEW_ROUTE_SEGMENT}`;
                trackNavigationClick(
                    `${window.location.pathname}${window.location.search};${reviewPath};Bottom Bar;designBriefNextButton`,
                    'designBriefNextButton'
                );

                nav(reviewPath);
            }}
            disabled={isProcessing}
            sm={{
                width: 'standard',
            }}
        >
            {__('Next')}
        </ResponsiveButton>
    );
};
